export { default } from 'shared/renderer/Renderer';
